export const GET_LOCATIONS_BY_RETAILER = 'GET_LOCATIONS_BY_RETAILER'
export const GET_LOCATIONS_BY_RETAILER_FULFILLED =
  'GET_LOCATIONS_BY_RETAILER_FULFILLED'
export const GET_LOCATIONS_BY_RETAILER_REJECTED =
  'GET_LOCATIONS_BY_RETAILER_REJECTED'

/**
 * @param {GetLocationsByRetailerPayload} payload
 * @returns {{payload: GetLocationsByRetailerPayload, type: string}}
 */
export const getLocationsByRetailer = (payload) => ({
  type: GET_LOCATIONS_BY_RETAILER,
  payload,
})
